// Nền bảng TKB: buổi chiều (tiết 6–10) tô màu cấu hình được (Xếp thời khoá biểu →
// Thời gian học → "Màu nền buổi chiều"); buổi sáng (tiết 1–5) giữ nguyên.
// Chỉ đổi những ô ĐANG CÓ TIẾT (nền xanh nhạt #EFF6FF). Ô trống (trắng), ô Bận (đỏ),
// ô nghề (vàng), ô tiết của mình (xanh lá), ô trùng bận (tím) giữ nguyên màu riêng.
// Dùng: import { periodShadeIndex } ở file bảng TKB rồi gắn data-pi={periodShadeIndex(p.global)} lên <tr>.
export const DEFAULT_END_SHADE = "#CCFFFF";

// 0 = buổi sáng (tiết 1–5), 1 = buổi chiều (tiết 6–10)
export const periodShadeIndex = (globalPeriod) => (Number(globalPeriod) >= 5 ? 1 : 0);

const validColor = (c) => (/^#[0-9a-fA-F]{6}$/.test(String(c || "")) ? c : DEFAULT_END_SHADE);

// Gọi lại bất cứ lúc nào để đổi màu ngay (không cần tải lại trang).
export const applyPeriodShade = (color) => {
  if (typeof document === "undefined") return;
  const c = validColor(color);
  let el = document.getElementById("hs-period-shade");
  if (!el) {
    el = document.createElement("style");
    el.id = "hs-period-shade";
    document.head.appendChild(el);
  }
  // rgb(239, 246, 255) = #EFF6FF = nền ô có tiết (trình duyệt chuẩn hoá màu trong thuộc tính style).
  el.textContent = `tr[data-pi="1"]>td[style*="rgb(239, 246, 255)"]{background-color:${c} !important;background-image:none !important}`;
};

applyPeriodShade(DEFAULT_END_SHADE);
